import React from 'react';
import { CheckmarkCircle20Filled } from '@fluentui/react-icons';
import { BusinessStatus, PlanActivationStatus } from 'enum/common';
import PausedOfferStatus from 'components/Home/PausedOfferStatus';

interface IRegisteredBusinessPlansProps {
  businessStatus?: BusinessStatus;
  planStatus?: PlanActivationStatus;
}

const RegisteredBusinessPlans = ({ businessStatus, planStatus }: IRegisteredBusinessPlansProps) => {
  const normalizedStatus = businessStatus?.toLowerCase();
  const isPaused = planStatus === PlanActivationStatus.PAUSED;

  const businessStatusText = React.useMemo(() => {
    if (isPaused) {
      return <PausedOfferStatus labelClassName="text-orange font-medium text-base" />;
    }

    switch (normalizedStatus) {
      case BusinessStatus.ACTIVATED:
        return <span className="font-medium text-base text-green">Active</span>;
      default:
        return <span className="font-medium text-base text-failed">Not Active</span>;
    }
  }, [isPaused, normalizedStatus]);

  return (
    <div>
      <div className="text-navyBlue text-xl font-semibold p-4 bg-white flex w-full md:flex-row flex-col rounded-lg">
        <div className="flex-1">List your business on Open Rewards</div>
        <div className="text-darkBlue text-base flex gap-1 flex-row items-center">
          {!isPaused && normalizedStatus === BusinessStatus.ACTIVATED && (
            <CheckmarkCircle20Filled color="green" className="self-center mb-[2px] md:mt-[2px]" />
          )}
          {!isPaused && <span className="text-black opacity-60 md:hidden">Status: </span>}
          <div className="font-medium self-end justify-end">{businessStatusText}</div>
        </div>
      </div>
    </div>
  );
};

export default RegisteredBusinessPlans;
